import { Component, inject, OnInit } from "@angular/core";
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import { StoreItemActions } from "../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../store/entities/store-item/store-item.model";
import { Store } from "@ngrx/store";
import { AppState } from "../../store";
import {
  ACTIVATE_OR_RESET_PASSWORD_MUTATION,
  CHANGE_PASSWORD_MUTATION
} from "../../store/entities/user-management/users/users.graphql";
import {NotificationService} from "../../services/notification.service";
import {SettingsService} from "../../services/settings.service";

@Component({
  selector: 'app-login',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  showPassword: boolean = false;
  showPassword2: boolean = false;

  private fb: FormBuilder = inject(FormBuilder)
  store: Store<AppState> = inject(Store<AppState>)

  form: FormGroup;
  loading = false;

  constructor(
      private notificationService: NotificationService,
      private  settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.form = this.fb.group(
        {
          oldPassword: [null, Validators.required],
          newPassword: [null, Validators.required],
        }
    );
  }

  submitForm(value) {
    this.loading = true;
    this.notificationService
        .confirmation({ message: "Are you sure you want to change?" })
        .then((result) => {
          if (result){
            const input = {
              ...value
            };
            this.store.dispatch(StoreItemActions.createUpdateStoreItem({
              entity: StoreItemEntity.user,
              input,
              mutation: CHANGE_PASSWORD_MUTATION,
              isInput: true
            }));
          }
          else{

          }
        });
    this.loading = false;
  }



  closeDialog() {
    this.settingsService.closeDialog(ResetPasswordComponent);
  }

}

